import { Injectable } from '@angular/core';
import { ServiceLibraryDetailsRequest, ServiceSchedule, YearsRequest, ServiceScheduleDetailResponse, ServiceScheduleEditResponse, AssetModel, ServiceTypesWebRequest } from '../models/service-library.models';
import { Response } from '../../../../_shared/models';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { AccountFilterRequest } from '../../../../_shared/models/account-filter.model';

@Injectable({
  providedIn: 'root'
})
export class ServiceLibraryService {
  private http: HttpClient = inject(HttpClient);

  async getModelOptionsAsync(serviceScheduleId: number, request: AccountFilterRequest, cancellation: Subject<void>): Promise<Response<AssetModel[]>> {
    return firstValueFrom(this.http.post<Response<AssetModel[]>>(`${environment.apiEndpoint}/servicelibrary/service-schedules/${serviceScheduleId}/models`, request).pipe(takeUntil(cancellation)));
  }

  async getYearsOptionsAsync(serviceScheduleId: number, request: YearsRequest, cancellation: Subject<void>): Promise<Response<number[]>> {
    return firstValueFrom(this.http.post<Response<number[]>>(`${environment.apiEndpoint}/servicelibrary/service-schedules/${serviceScheduleId}/years`, request).pipe(takeUntil(cancellation)));
  }

  async GetServiceTypesByServiceScheduleModelAndYear(serviceScheduleId: number, request: ServiceTypesWebRequest, cancellation: Subject<void>): Promise<Response<number[]>> {
    return firstValueFrom(this.http.post<Response<number[]>>(`${environment.apiEndpoint}/servicelibrary/service-schedules/${serviceScheduleId}/service-types`, request).pipe(takeUntil(cancellation)));
  }

  async getServiceScheduleDetailsAsync(request: ServiceLibraryDetailsRequest, cancellation: Subject<void>): Promise<Response<ServiceScheduleDetailResponse>> {
    return firstValueFrom(this.http.post<Response<ServiceScheduleDetailResponse>>(`${environment.apiEndpoint}/servicelibrary/service-schedules/${request.id}/details`, request).pipe(takeUntil(cancellation)));
  }

  async getServiceSchedulesAsync(request: AccountFilterRequest, cancellation: Subject<void>): Promise<Response<ServiceSchedule[]>> {
    return firstValueFrom(this.http.post<Response<ServiceSchedule[]>>(`${environment.apiEndpoint}/servicelibrary/service-schedules/filter`, request).pipe(takeUntil(cancellation)));
  }

  async deleteServiceScheduleAsync(id: number): Promise<Response<any>> {
    return firstValueFrom(this.http.delete<Response<any>>(`${environment.apiEndpoint}/servicelibrary/${id}`))
  }

  async getServiceScheduleById(id: number): Promise<Response<ServiceScheduleEditResponse>> {
    return firstValueFrom(this.http.get<Response<ServiceScheduleEditResponse>>(`${environment.apiEndpoint}/servicelibrary/service-schedules/${id}`));
  }

  async upsertServiceScheduleAsync(payload: any): Promise<Response<any>> {
    return firstValueFrom(this.http.post<Response<any>>(`${environment.apiEndpoint}/servicelibrary/service-schedules`, payload));
  }

  async updateIntervalPartsAsync(scheduleId: number, serviceTypeId: number, partTypeIds: number[]): Promise<Response<any>> {
    return firstValueFrom(this.http.post<Response<any>>(`${environment.apiEndpoint}/servicelibrary/service-schedules/${scheduleId}/parts`, { serviceTypeId, partTypeIds }));
  }

  async getConnectedServiceLibraryStatsKpi(request: AccountFilterRequest, cancellation: Subject<void>): Promise<Response<number>> {
    return firstValueFrom(this.http.post<Response<number>>(`${environment.apiEndpoint}/servicelibrary/connected-service-libraries-summary`, request).pipe(takeUntil(cancellation)));
  }

  async getUpcomingMaintenanceStatsKpi(request: AccountFilterRequest, cancellation: Subject<void>): Promise<Response<number>> {
    return firstValueFrom(this.http.post<Response<number>>(`${environment.apiEndpoint}/servicelibrary/upcoming-maintenance-summary`,  request).pipe(takeUntil(cancellation)));
  }

  async getDisconnectedUnitsStatsKpi(request: AccountFilterRequest, cancellation: Subject<void>): Promise<Response<number>> {
    return firstValueFrom(this.http.post<Response<number>>(`${environment.apiEndpoint}/servicelibrary/disconnected-units-summary`, request).pipe(takeUntil(cancellation)));
  }

  async getVehicleMakesStatsKpi(request: AccountFilterRequest, cancellation: Subject<void>): Promise<Response<number>>  {
    return firstValueFrom(this.http.post<Response<number>>(`${environment.apiEndpoint}/servicelibrary/vehicle-makes-summary`, request).pipe(takeUntil(cancellation)));
  }
}